export default __webpack_public_path__ + "static/media/icon-warning-yellow.8287c4ed.svg";